export default __webpack_public_path__ + "static/media/faqArrowUp.f91b2d68.svg";